import Card from '@mui/material/Card'
import styled from '@mui/material/styles/styled'

export const CustomFieldCard = styled(Card, {
  name: 'CustomFieldCard',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
  justifyContent: 'space-between',
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
}))
